export const BASE_IM_CONFIG = {
  delivery: true,
  heartBeatWait: 4500,
  useOwnUploadFun: false,
  autoReconnectNumMax: 2,
  isHttpDNS: true,
};

export const APP_KEY = {
  talkie: {
    test: '1172230614161023#talkie-test',
    prod: '1172230614161023#talkie',
  },
  xingye: {
    test: '1147220623101786#xingye-test',
    prod: '1147220623101786#xingye',
  },
};
